import { Injectable } from '@angular/core';
import { load, Root } from 'protobufjs';
import { Buffer } from 'buffer';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MatchProtoService {
  root: Root | null = null;

  fileProto = environment.protoMatchtUrl;

  async loadProto(): Promise<Root> {
    if (this.root) return this.root;

    return new Promise((resolve, reject) => {
      load(this.fileProto, (err, root: any) => {
        if (err) {
          console.error('Error loading .proto file:', err);
          reject(err);
        } else {
          this.root = root;
          // console.log({ root });
          resolve(root);
        }
      });
    });
  }

  async decodeResponse(buffer: Blob): Promise<any> {
    const root = await this.loadProto();

    const GenericResponse = root.lookupType('client_events.GenericResponse');
    const arrayBuffer = await buffer.arrayBuffer();
    const byteBuffer = Buffer.from(new Uint8Array(arrayBuffer));
    const decoded = GenericResponse.decode(byteBuffer);

    return GenericResponse.toObject(decoded, { defaults: true });
  }

  encodeRequest(requestBody: object): Uint8Array {
    if (!this.root) throw new Error('[Proto] root not loaded');

    const GenericRequest = this.root.lookupType('client_events.GenericRequest');
    const errMsg = GenericRequest.verify(requestBody);
    if (errMsg) throw new Error(errMsg);

    return GenericRequest.encode(requestBody).finish();
  }
}
